import { Toast, Modal } from 'antd-mobile';

const prompt = Modal.prompt;

const Number = 5;

export const MessagesFail = (msg, callback) => {
    Toast.fail(msg, Number, callback);
};

export const MessagesSuccess = (msg, callback) => {
    Toast.success(msg, Number, callback);
};

export const MessageWarning = (msg, callback) => {
  Toast.offline(msg, Number, callback);
};

export const LoadingAlert = (msg, number) => {
  Toast.loading(msg || '载入中...', number || 0);
};

export const LoadingHide = () => {
  Toast.hide();
};

export const MessageConfirm = (msg) => {
    return new Promise((resolve,reject) => {
        Modal.alert('提示', msg,[
            {
                text: '确定',
                onPress: value => {
                    resolve(value);
                },
            },
            {
                text: '取消',
                onPress: value => {
                    reject(value);
                },
            },
           
        ]);
    });
}

export const MessagePrompt = (msg) => {
    return new Promise((resolve,reject) => {
        prompt('提示', msg,[
            {
                text: '确定',
                onPress: value => {
                    resolve(value);
                },
            },
            {
                text: '取消',
                onPress: value => {
                    reject(value);
                },
            },
           
        ], 'default', null);
    });
}
  

export function TimeInterval (callback)  {

    let clockObj = null;
  
    let duration = -1;
  
    const plusTime = () => {
        duration = duration + 1000;
    }
  
    const timeClock = () => {
        if (duration > -1) {
            if(callback) callback(duration);
        }
      }
  
    this.start = () => {
        timeClock();
        clearInterval(clockObj);
        clockObj = setInterval(() => {
            if (duration > -1) {
                plusTime();
                timeClock();
            }
        }, 1000);
    }
    this.stop = () => {
        clearInterval(clockObj);
    }
    this.setTime = (time) => {
        duration = time;
    }
    this.getTime = () => {
        return duration;
    }
}

// 超时时间,单位分钟
const TIME_OUT = 5;
// 时间器定时间距
const TIME_BEAT = 1

export function CheckTimeInterval (callback)  {

    let clockObj = null;

    let startTime = -1;

    let endTime = -1;

    let currect = -1;

    const checkTime = () => {
        if (startTime > -1 && endTime > -1 && currect > -1) {
          if (endTime - (startTime + currect) <= TIME_OUT * 60 * 1000){
            if (callback) callback(true);
          }
        }
    }

    this.start = () => {
        checkTime();
        clearInterval(clockObj);
        clockObj = setInterval(() => {
          checkTime()
        }, TIME_BEAT * 60 * 1000);
    }
    
    this.setParam = (param) => {
        currect = param.currect;
        startTime = param.startTime;
        endTime = param.endTime;
    }

    this.stop = () => {
        clearInterval(clockObj);
    }

}
